<template>
  <div :class="isPc ? 'signin' : ''">
    <IconSwitch :type="'qrcode'"></IconSwitch>
    <Icon></Icon>
    <el-collapse-transition>
      <Error v-show="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>

    <Inputs :type="'account'" :data="account" v-on:inputText="getAccount" v-on:enterInput="enterInput" v-show="!passwordShow"></Inputs>
    <el-collapse-transition>
      <Warn :type="'accountnotexist'" :data="account" v-if="notExist"></Warn>
    </el-collapse-transition>
    <Account style="margin-top: 38px;" :content="account" v-on:showPassword="showPassword" v-show="passwordShow"></Account>

    <div class="password-input" :style="{marginTop: (!passwordShow ? '-70px' : '0'), opacity: (!passwordShow ? '0' : '1')}">
      <Inputs :type="'password'" v-on:inputText="getPassword" v-on:rememberpw="getRememberpw" v-on:enterInput="enterInput" :remember="{password, rememberpw}" :change="change"></Inputs>
    </div>

    <Buttons ref=btn :type="'signin'" :data="account" v-on:accountNotExist="accountNotExist" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" v-on:showPassword="showPassword" v-if="!passwordShow"></Buttons>
    <Buttons ref=btn :type="'login'" style="margin-top: 60px;" :style="{marginBottom: (!isEmail && !isPhone ? '80px' : '')}" :data="{type: type, password: password, account: account}" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" v-on:loginSuccess="loginSuccess" v-if="passwordShow"></Buttons>

    <Foot :type="'No using crait'" style="margin-bottom: 0px;" v-if="!passwordShow && !isGenericVersion"></Foot>
    <Foot :type="'Forgot password'" :isEmail="isEmail ? true : false" :account="account" style="margin-top: 15px;margin-bottom: 44px;" v-if="passwordShow && (isEmail || isPhone)"></Foot>
  </div>
</template>

<script>
  import Vue from 'vue'
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Inputs from '../components/Inputs'
  import Account from '../components/Account'
  import Warn from '../components/Warn'
  import Buttons from '../components/Buttons'
  import Foot from '../components/Foot'
  import { errorFn } from '../common/ErrorMsg.js'
  import RememberPassword from '../common/RememberPassword.js'
  import { checkEmail, checkPhone, checkUsername, checkIsChrome, isTablet } from '../common/Common.js'
  // import config from '../../assets/js/config.js'
  import AppInfo from '../../appInfo/index'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        account: '', // 输入的账号
        notExist: false,
        type: 0,
        rememberPassword: '',
        // account: this.$route.query.account,
        password: '',
        rememberpw: false,
        isEmail: '',
        isPhone: '',
        isAccount: '',
        passwordShow: false,
        change: 0,
        isGenericVersion: AppInfo.isGenericVersion()
      }
    },
    components: {
      IconSwitch, Icon, Error, Inputs, Account, Warn, Buttons, Foot
    },
    props: ['isPc'],
    created () {
      this.getRememberedPassword()
    },
    mounted () {
      if (location.search.indexOf('?ua=') > -1 && location.search.indexOf('&version=') > -1) {
        let version = location.search.substr((location.search.indexOf('&version=') + 9))
        let pcVersion = 'pc/' + version
        localStorage.setItem('pcVersion', pcVersion)
      }
      // 浏览器检测
      if (checkIsChrome()) {
        let ua = navigator.userAgent.toLowerCase()
        let s = ua.match(/chrome\/([\d.]+)/)
        if (parseInt(s[1]) < 62 && !(ua.indexOf('electron') > -1)) {
          Vue.prototype.$message({
            showClose: true,
            message: 'The version of Chrome you are using is old. Update your browser to optimize user experience.',
            type: 'warning',
            duration: 0
          })
        }
      } else if (!isTablet()) {
        let messageTip = 'We highly recommend you to use ' + AppInfo.getfirstUpperCaseAppName() + ' in Chrome for optimized user experience.'
        Vue.prototype.$message({
          showClose: true,
          message: messageTip,
          type: 'warning',
          duration: 0
        })
      }
    },
    methods: {
      getRememberedPassword (data) {
        this.rememberPassword = new RememberPassword()
        if (JSON.parse(localStorage.getItem('passwords')) && JSON.parse(localStorage.getItem('passwords'))[0]) {
          let account = data || Object.keys(JSON.parse(localStorage.getItem('passwords'))[0])[0]
          if (account !== 'undefined') {
            this.password = this.rememberPassword.getPassword(account)
            this.rememberpw = this.password !== ''
            this.passwordShow = true
            this.passwordPageInit()
          }
        }
      },
      getAccount (data) {
        this.account = data
        this.notExist = false
      },
      checkError (msg) {
        this.openErrorTip(msg)
      },
      accountNotExist () {
        this.errorShow = false
        this.notExist = true
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 显示输入密码框
      showPassword (data) {
        this.passwordShow = data
        this.errorShow = false
        if (data) {
          // let passwords = localStorage.getItem('passwords')
          // if (passwords) {
          //   let account = Object.keys(JSON.parse(passwords)[0])[0]
          //   if (account !== this.account) {
          //     this.password = ''
          //     this.rememberpw = false
          //   }
          // }
          this.getRememberedPassword(this.account)
          ++this.change
          this.passwordPageInit()
        }
      },
      // 输入密码页初始化
      passwordPageInit () {
        setTimeout(() => {
          this.isEmail = checkEmail(this.account)
          this.isPhone = checkPhone(this.account)
          this.isAccount = checkUsername(this.account)
          if (this.isEmail) {
            this.type = 0
          } else if (this.isPhone) {
            this.type = 1
          } else if (this.isAccount) {
            this.type = 2
          }
          document.getElementsByClassName('inputs')[1].focus()
        }, 0)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      },
      // 获取密码
      getPassword (data) {
        this.password = data
      },
      // 获取记住密码状态
      getRememberpw (data) {
        this.rememberpw = data
      },
      // 登录成功回调
      loginSuccess (password) {
        if (password !== void 0) {
          this.rememberPassword.savePassword(this.account, password, this.rememberpw)
        } else {
          this.$router.push({path: '/login/scan'})
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .signin {
    .white-bg();
    min-height: 420px;
    margin-top: -210px;
    .password-input {
      position: relative;
      z-index: -1;
      transition: all 0.5s;
    }
  }
</style>



// WEBPACK FOOTER //
// Signin.vue?5d0198fa